import InlineEditableGrid from './inline-editable-grid.components'

export default InlineEditableGrid